import { render, staticRenderFns } from "./MFormVuetifyAddressPicker.vue?vue&type=template&id=51f32aa9&scoped=true"
import script from "./MFormVuetifyAddressPicker.vue?vue&type=script&lang=js"
export * from "./MFormVuetifyAddressPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f32aa9",
  null
  
)

export default component.exports